var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from "react";
import * as Styled from "./play-line.style";
import { chartDrawingAreaStart, chartDrawingAreaWidth, } from "ui/components/panels/graphs/constants";
// How long the draggable handle wiggles to hint at its draggability after the
// graph panel opens, before settling for good.
var DRAG_HINT_DURATION_MS = 7500;
export var PlayLine = function (_a) {
    var playLocationPercent = _a.playLocationPercent, label = _a.label, bottomOffset = _a.bottomOffset, onHandleMouseDown = _a.onHandleMouseDown;
    // Wiggle on mount (i.e. when the graph panel opens), then stop permanently
    // after the timeout or as soon as the pointer enters the handle.
    var _b = __read(useState(true), 2), isHinting = _b[0], setIsHinting = _b[1];
    useEffect(function () {
        var timeout = setTimeout(function () { return setIsHinting(false); }, DRAG_HINT_DURATION_MS);
        return function () { return clearTimeout(timeout); };
    }, []);
    return (_jsxs(Styled.PlayLine, { bottomOffset: bottomOffset, style: {
            // Snap to a whole pixel so the 2px line renders crisply on the pixel grid
            // instead of antialiasing across two columns (which made it look ~1px off
            // from the SVG reference lines it should sit on).
            left: Math.round(chartDrawingAreaStart + playLocationPercent * chartDrawingAreaWidth),
        }, children: [onHandleMouseDown && (_jsx(Styled.Handle, { hinting: isHinting, onMouseEnter: function () { return setIsHinting(false); }, onMouseDown: onHandleMouseDown, onClick: function (e) { return e.stopPropagation(); }, children: _jsxs("svg", { width: "44", height: "20", viewBox: "0 0 44 20", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("rect", { x: "0", y: "0", width: "44", height: "20", rx: "3", fill: "#2a2d35" }), _jsx("polyline", { points: "10,4 4,10 10,16", stroke: "white", strokeWidth: "2", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("circle", { cx: "22", cy: "10", r: "8", fill: "white" }), _jsx("circle", { cx: "22", cy: "10", r: "5", fill: "#d4b94a" }), _jsx("polyline", { points: "34,4 40,10 34,16", stroke: "white", strokeWidth: "2", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" })] }) })), label && _jsx(Styled.Label, { children: label })] }));
};
